<template>
  <router-link :to="{name: group+'Detail', params: {id: profile._id}}" target="_blank">
    <v-card elevation="0">
      <v-card-title class="d-flex justify-center">
        <v-avatar size="80">
          <img
            alt="user"
            :src="profile.publicProfilePicture"
          >
        </v-avatar>
      </v-card-title>
      <v-card-text class="d-flex justify-center">
        <v-list-item two-line class="px-0 d-inline-block">
          <h3 class="text-center">{{profile.name}}</h3>
        </v-list-item>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-chip class="text-center headline white--text" label :style="{backgroundColor: color}">{{label}}</v-chip>
      </v-card-actions>
    </v-card>
  </router-link>
</template>

<script>
    export default {
        name: "ProfileCard",
        props: {
          profile: {
            type: Object
          },
          group: {
            type: String,
            default: 'staff'
          }
        },
      computed: {
          color() {
            return this.group === 'staff' ? this.profile.engagementColor : this.profile.riskColor
          },
          label() {
            return this.group === 'staff' ? this.profile.engagementLabel : this.profile.riskLabel
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/ProfileCard.vue